// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GQUGHGLXYxi7VCsVmz9d {
  display: grid;
  gap: 0.6rem;
}

.BTchQp_eClvmdPTE10at {
  border-collapse: collapse;
  width: 100%;
}

.BTchQp_eClvmdPTE10at th {
  text-align: left;
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--c-muted);
  padding: 0 0.4rem 0.3rem;
}

.BTchQp_eClvmdPTE10at td {
  padding: 0.3rem 0.4rem;
  border-top: 0.1rem solid var(--cl-main-disabled-transparent-2);
  vertical-align: middle;
}

.qSSuAmNFKty6uWpl7RrD {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  white-space: nowrap;
}

.Nsiz4qRUP5n1Wyjt3x5Z {
  color: #c0392b;
  font-size: 0.85rem;
}

.IV4U4rxjNXwuXZy5xsor {
  justify-self: start;
}
`, "",{"version":3,"sources":["webpack://./src/merchant/panel/scripts/shared/IntProvider/TiersTable.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,8DAA8D;EAC9D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".tiers {\n  display: grid;\n  gap: 0.6rem;\n}\n\n.table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.table th {\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: var(--c-muted);\n  padding: 0 0.4rem 0.3rem;\n}\n\n.table td {\n  padding: 0.3rem 0.4rem;\n  border-top: 0.1rem solid var(--cl-main-disabled-transparent-2);\n  vertical-align: middle;\n}\n\n.range {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  white-space: nowrap;\n}\n\n.error {\n  color: #c0392b;\n  font-size: 0.85rem;\n}\n\n.add {\n  justify-self: start;\n}\n"],"sourceRoot":""}]);
// Exports
export var tiers = `GQUGHGLXYxi7VCsVmz9d`;
export var table = `BTchQp_eClvmdPTE10at`;
export var range = `qSSuAmNFKty6uWpl7RrD`;
export var error = `Nsiz4qRUP5n1Wyjt3x5Z`;
export var add = `IV4U4rxjNXwuXZy5xsor`;
export default ___CSS_LOADER_EXPORT___;
